import type { Profile } from '@/contexts/auth-context';

const ROLE_DISPLAY_MAP: Record<string, string> = {
  assistant: 'Assistant',
  junior: 'Junior Accountant',
  senior: 'Senior Accountant',
  partner: 'Partner',
  admin: 'Administrator',
  accountant: 'Accountant',
};

export const getRoleDisplayName = (role?: string | null): string => {
  if (!role) return 'Accountant';
  return ROLE_DISPLAY_MAP[role] ?? role;
};

export const getUserInitials = (
  firstName?: string | null,
  lastName?: string | null,
  fallback = 'SF'
): string => {
  const firstInitial = firstName?.trim().charAt(0) ?? '';
  const lastInitial = lastName?.trim().charAt(0) ?? '';
  const initials = `${firstInitial}${lastInitial}`.toUpperCase();
  return initials || fallback;
};

export const getProfileInitials = (profile?: Profile | null, fallback = 'SF') =>
  getUserInitials(profile?.first_name, profile?.last_name, fallback);
